/** @format */

import React from 'react'

import styles from './Modal.module.scss'

export const Modal = ({ handleModal }) => {
  return (
    <>
      <div className={styles.wrapper}>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci amet
        atque consectetur cum debitis delectus dicta eligendi expedita inventore
        iste laboriosam modi nihil, nobis odit officiis quam quis similique sit
        totam unde ut, vel voluptates. Adipisci amet commodi ea facere magnam
        minima molestiae quod saepe. Ab commodi esse et eveniet facilis impedit
        inventore mollitia nihil placeat quis reprehenderit repudiandae
        similique, sint suscipit voluptatum. Adipisci aperiam, consequuntur
        cumque distinctio explicabo id illo ipsa, molestias nobis, nulla placeat
        repellendus sint suscipit totam ut! A alias asperiores assumenda commodi
        distinctio dolor dolorum earum eius, eveniet facilis fugit id laboriosam
        magni nemo nisi obcaecati perferendis quae quia quod ratione reiciendis
        sed similique suscipit voluptate voluptatum? Adipisci aspernatur cumque
        dicta distinctio dolor dolorem ducimus ea eius esse exercitationem iste
        iure magni natus necessitatibus nihil numquam odit perferendis porro
        quaerat quia quibusdam quidem quis quod recusandae rem reprehenderit
        sapiente temporibus unde veniam veritatis voluptate voluptates,
        voluptatum?
      </div>
      <div className={styles.overlay} onClick={handleModal} />
    </>
  )
}
